import { useNavigate } from "react-router-dom";

export default function BotaoVoltar({ to, label = "Voltar" }) {
  const navigate = useNavigate();

  return (
    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={() => navigate(to)}
    >
      ← {label}
    </button>
  );
}
